import { flatMap, map, get, uniqBy, find } from 'lodash';
import { buildCgiImageForCompare } from '../../../../api/config/normalizeCGI';

export const getAvailablePowertrains = (trimMatrix, translate) => {
  const { trims, engines, transmissions } = trimMatrix;
  const configurations = flatMap(trims, 'configurations');

  const powertrains = map(configurations, (config) => {
    const engineCode = get(config, 'engine.code');
    const transmissionCode = get(config, 'transmission.code');
    const description = translate('powertrain.combination.v3', {
      engine: find(engines, { id: engineCode })?.description,
      transmission: find(transmissions, { id: transmissionCode })?.description,
    });

    return {
      id: `${engineCode}_${transmissionCode}`,
      engineCode,
      transmissionCode,
      description,
    };
  });

  return uniqBy(powertrains, 'id');
};

export const getAvailableDriveAndWheelTypes = (bodyTypes) => {
  const driveAndWheelTypes = flatMap(bodyTypes, 'driveTypes');

  const normalizeDriveAndWheelTypes = driveAndWheelTypes?.map(
    (driveAndWheelType) => {
      const {
        driveType,
        description,
        rearWheelType,
        label,
      } = driveAndWheelType;
      return {
        id: `${driveType}${rearWheelType ? `-${rearWheelType}` : ''}`,
        driveType: driveType,
        rearWheelType: rearWheelType || '',
        description: description,
        label,
      };
    }
  );

  return uniqBy(normalizeDriveAndWheelTypes, 'id');
};

export const normalizeBodyCompareData = (trims, bodyTypes, cgiSize) => {
  return trims.map((trim) => {
    const {
      msrp,
      cgiImageUrl,
      styleId,
      driveType,
      bodyTypeId,
      cabSize,
      configurations,
    } = trim;

    const { rearWheelType } = driveType;
    return {
      id: `${driveType.id}${cabSize ? `_${cabSize}` : ''}${
        rearWheelType ? `_${rearWheelType}` : ''
      }`,
      bodyTypeId,
      cabSize,
      rearWheelType: driveType.rearWheelType,
      msrp: msrp?.unknown || msrp?.amount.text,
      driveTypeId: driveType.id,
      cgiImageUrl: buildCgiImageForCompare(cgiImageUrl, cgiSize),
      styleId,
      configurations: map(configurations, (configuration) => {
        return {
          ...configuration,
          engineCode: configuration.engine.code,
          transmissionCode: configuration.transmission.code,
        };
      }),
      description: find(bodyTypes, { id: bodyTypeId }).description,
    };
  });
};

export const getCapabilitiesbyEngineRowId = (
  capabilities,
  bodyTypeId,
  driveAndWheelType,
  engine
) => {
  const key = `${bodyTypeId}_${driveAndWheelType?.driveType}_${engine?.engineCode}`;
  return capabilities?.engineRowData[key];
};
